import React from 'react'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars-2'

import './custom-scroll.scss'

const CustomScrollBar = ({ autoHeight, autoHeightMin, autoHeightMax, children }) => {
  const renderThumbVertical = ({ style, ...props }) => (
    <div
      style={style}
      {...props}
      className="custom-scroll-thumb"
    />
  )
  const renderTrackVertical = ({ style, ...props }) => (
    <div
      style={style}
      {...props}
      className="custom-scroll-track"
    />
  )

  const renderTrackHorizontal = ({ style, ...props }) => (
    <div
      style={style}
      {...props}
      className="custom-scroll-track-horizontal"
    />
  )

  const renderThumbHorizontal = ({ style, ...props }) => (
    <div
      style={style}
      {...props}
      className="custom-scroll-thumb-horizontal"
    />
  )

  return (
    <Scrollbars
      autoHeight={autoHeight || false}
      autoHeightMax={autoHeightMax || 0}
      autoHeightMin={autoHeightMin || 0}
      hideTracksWhenNotNeeded
      renderThumbVertical={renderThumbVertical}
      renderTrackVertical={renderTrackVertical}
      renderTrackHorizontal={renderTrackHorizontal}
      renderThumbHorizontal={renderThumbHorizontal}
    >
      {children}
    </Scrollbars>
  )
}

CustomScrollBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  autoHeight: PropTypes.bool,
  autoHeightMax: PropTypes.number,
  autoHeightMin: PropTypes.number
}

export default CustomScrollBar
